const CATEGORY_WORD_PATTERN = '(?:meds?|medication|medicine|behavior|behaviour|mood|activity|food|sleep|toilet(?:ing)?|bathroom|health|milestone|note|log)';
const CLASSIFIER_WORD_PATTERN = '(?:classif(?:y|ied|ies|ying)|categor(?:y|ize|ized|izes|izing)|label(?:ed|led|s|ing)?|called|calling)';
const META_SUBJECT_PATTERN = '(?:this|that|it|the\\s+note|this\\s+note|the\\s+entry|this\\s+entry)';

const META_COMMENTARY_SENTENCE_PATTERNS = [
  new RegExp(`^${META_SUBJECT_PATTERN}\\b.{0,60}\\b${CLASSIFIER_WORD_PATTERN}\\b.{0,40}\\b${CATEGORY_WORD_PATTERN}\\b`, 'i'),
  new RegExp(`^why\\b.{0,40}\\b${META_SUBJECT_PATTERN}\\b.{0,80}\\b${CLASSIFIER_WORD_PATTERN}\\b`, 'i'),
  new RegExp(`^${META_SUBJECT_PATTERN}\\b.{0,50}\\bshould(?:n['’]?t)?\\s+(?:be\\s+)?(?:${CLASSIFIER_WORD_PATTERN}\\s+(?:as\\s+)?)?${CATEGORY_WORD_PATTERN}\\b`, 'i'),
  /^(?:wrong|bad|incorrect)\s+(?:classification|category|label)\b/i,
];

const INLINE_META_COMMENTARY_PATTERNS = [
  new RegExp(`\\b${META_SUBJECT_PATTERN}\\b.{0,60}\\b${CLASSIFIER_WORD_PATTERN}\\b.{0,40}\\b${CATEGORY_WORD_PATTERN}\\b[.!?]*`, 'gi'),
  new RegExp(`\\bwhy\\b.{0,40}\\b${META_SUBJECT_PATTERN}\\b.{0,80}\\b${CLASSIFIER_WORD_PATTERN}\\b[.!?]*`, 'gi'),
  new RegExp(`\\b${META_SUBJECT_PATTERN}\\b.{0,50}\\bshould(?:n['’]?t)?\\s+(?:be\\s+)?(?:${CLASSIFIER_WORD_PATTERN}\\s+(?:as\\s+)?)?${CATEGORY_WORD_PATTERN}\\b[.!?]*`, 'gi'),
];

const cleanSpacing = (value = '') => String(value || '')
  .replace(/\s+([.!?,;:])/g, '$1')
  .replace(/\s+/g, ' ')
  .trim();

export const isQuickLogMetaCommentary = (text = '') => {
  const value = cleanSpacing(text);
  if (!value) {
    return false;
  }

  return META_COMMENTARY_SENTENCE_PATTERNS.some((pattern) => pattern.test(value));
};

export const stripQuickLogMetaCommentary = (text = '') => {
  const rawText = String(text || '').trim();
  if (!rawText) {
    return '';
  }

  const sentences = rawText.match(/[^.!?\n]+(?:[.!?]+|$)/g) || [rawText];
  const withoutMetaSentences = sentences
    .map((sentence) => sentence.trim())
    .filter((sentence) => sentence && !isQuickLogMetaCommentary(sentence))
    .join(' ');

  const withoutInlineMeta = INLINE_META_COMMENTARY_PATTERNS.reduce(
    (currentText, pattern) => currentText.replace(pattern, ''),
    withoutMetaSentences
  );

  return cleanSpacing(withoutInlineMeta);
};
